import { handleNoturarObjects, handleTurarObjects, handleXatlovActivate } from "../../../views/pages/Layers/Map/store/actions/xatlov"
import { handleDeleteAreaAction } from "../map"

export const setXatlovPoints = (val) => (dispatch) => dispatch({ type: "SET_XATLOVPOINTS", val })
export const setAllHouse = (val) => (dispatch) => dispatch({ type: "SET_ALLHOUSE", val })
export const setTurarNoturar = (val) => (dispatch) => dispatch({ type: "SET_TURARNOTURARDATA", val })
export const setTurarNoturarLine = (val) => (dispatch) => dispatch({ type: "SET_TURARNOTURARLINE", val })
export const setLine = (val) => (dispatch) => dispatch({ type: "SET_LINE", val })
export const AllRemove = (map, layer, onlistfunc, turarNoturar) => (dispatch) => {
  if (layer) map.removeLayer(layer)
  map.pm.disableGlobalRemovalMode()
  if (typeof onlistfunc === "function") onlistfunc?.removeOnListMarkers()
  turarNoturar.removeXatlov()
  dispatch(handleXatlovActivate(false))
  dispatch(handleNoturarObjects(null, null, []))
  dispatch(handleTurarObjects(null, null, []))
  dispatch(handleDeleteAreaAction(true))
}
